// 添加允许的语言常量
export const localeOptions: App.I18n.LangOption[] = [
  { label: "English", key: "en-US" },
  { label: "Español", key: "es-ES" },
  { label: "中文", key: "zh-CN" },
  { label: "ไทย", key: "th-TH" },
  { label: "Tiếng Việt", key: "vi-VN" },
  { label: "한국어", key: "ko-KR" },
  { label: "Kreyòl Ayisyen", key: "ht-HT" },
];

export const allowedLanguages = localeOptions.map((option) => option.key);